import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LorenEntityFormComponent } from "./components/loren-entity-form/loren-entity-form.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";

import { LorenEntityFormFieldComponent } from "./components/loren-entity-form-field/loren-entity-form-field.component";
import { ColorPickerModule } from "ngx-color-picker";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LorenPeriodSelectorModule } from "../loren-period-selector/loren-period-selector.module";
import { LorenDateFieldComponent } from "./components/loren-date-field/loren-date-field.component";
import { LorenImageModule } from "../../pipes/loren-image/loren-image.module";
import { TranslocoModule } from "@jsverse/transloco";
import {CdkDrag, CdkDropList} from "@angular/cdk/drag-drop";

const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "DD MMMM YYYY",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};

@NgModule({
  declarations: [
    LorenEntityFormComponent,
    LorenEntityFormFieldComponent,
    LorenDateFieldComponent,
  ],
  exports: [
    LorenEntityFormComponent,
    LorenEntityFormFieldComponent,
    LorenDateFieldComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,

        MatDatepickerModule,
        MatNativeDateModule,
        ColorPickerModule,
        LorenPeriodSelectorModule,
        MatIconModule,
        MatAutocompleteModule,
        LorenImageModule,
        MatSlideToggleModule,
        MatButtonModule,
        MatDividerModule,
        TranslocoModule,
        CdkDropList,
        CdkDrag,
    ],
})
export class LorenEntityFormModule {}
